const template = `
  <style>
    :host {
      display: block;
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    ::slotted(*) {
      width: 100%;
      height: 100%;
      overflow-y: auto;
    }

    .arrow-up,
    .arrow-down {
      position: absolute;
      left: 50%;
      transform: rotate(90deg) translateX(-50%);
      width: 20px;
      height: 30px;
      display: flex;
      cursor: pointer;
      z-index: 10;
      opacity: 0;
      transition: opacity 0.2s ease;
      pointer-events: none;
    }

    .arrow-up {
      top: 10px;
          left: 22px;
    }

    .arrow-down {
          bottom: -6px;
    left: 22px;
    }

    .arrow-up.visible,
    .arrow-down.visible {
      opacity: 1;
      pointer-events: auto;
    }
  </style>

  <slot></slot>
  <div class="arrow-up"><svg viewBox="0 0 100 100"><path fill="#333" d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></div>
  <div class="arrow-down"><svg viewBox="0 0 100 100"><path fill="#333" d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>
`;

class ScrollShadowElement extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' }).innerHTML = template;

    this.arrowUp = this.shadowRoot.querySelector('.arrow-up');
    this.arrowDown = this.shadowRoot.querySelector('.arrow-down');
    this.scrollContainer = null;

    this.onScroll = this.onScroll.bind(this);
    this.scrollUp = this.scrollUp.bind(this);
    this.scrollDown = this.scrollDown.bind(this);
  }

  connectedCallback() {
    // Get the slotted element (first child)
    this.scrollContainer = this.querySelector('*');
    
    if (this.scrollContainer) {
      this.scrollContainer.addEventListener('scroll', this.onScroll);
      this.arrowUp.addEventListener('click', this.scrollUp);
      this.arrowDown.addEventListener('click', this.scrollDown);
      this.onScroll(); // Initialize on load
    } else {
      console.warn('No scrollable element found inside <scroll-shadow>');
    }
  }

  disconnectedCallback() {
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.onScroll);
      this.arrowUp.removeEventListener('click', this.scrollUp);
      this.arrowDown.removeEventListener('click', this.scrollDown);
    }
  }

  onScroll() {
    if (!this.scrollContainer) return;

    const { scrollTop, scrollHeight, clientHeight } = this.scrollContainer;

    // Show/hide arrows based on scroll position
    if (scrollTop > 0) {
      this.arrowUp.classList.add('visible');
    } else {
      this.arrowUp.classList.remove('visible');
    }

    if (scrollTop + clientHeight < scrollHeight) {
      this.arrowDown.classList.add('visible');
    } else {
      this.arrowDown.classList.remove('visible');
    }
  }

  scrollUp() {
    if (this.scrollContainer) {
      this.scrollContainer.scrollBy({ top: -100, behavior: 'smooth' });
    }
  }

  scrollDown() {
    if (this.scrollContainer) {
      this.scrollContainer.scrollBy({ top: 100, behavior: 'smooth' });
    }
  }
}

customElements.define('scroll-shadow', ScrollShadowElement);
